import React from 'react';


export default class TreinosDores extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;

    return(
      <div>
        <strong>Informações para quem tem dores nos joelhos/coluna</strong><br /><br />
        Se você tem dores, hernias, protusão, artrose, contropatias...<br /><br />

Atenção à postura em todo e qualquer exercício.<br />
A qualidade técnica e segurança na execução é sempre prioridade.<br />
A coluna alinhada em todo o movimento de cada variação de exercício preserva sua integridade.<br />
O alinhamento dos joelhos com os pés conforme os vídeos é imprescindível.<br />

Evitar agachamento ou algum bom exercício por casos como o seu é uma tolice absurda que muitos profissionais da saúde ainda o fazem por falta de CONHECIMENTO CIENTÍFICO.<br />

Faça mais PONTES e menos abdominais no caso de problemas na coluna.<br />

PREFIRA bike no lugar da corrida no caso de condropatia nos joelhos.

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/TreinosDores.js